import React, { useCallback, useEffect, useState } from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import { displayFormat } from '../util/money'

interface Props {
	user: any
	userId: string
}

const UserDetails: React.FC<Props> = ({ user, userId }) => {
	const [isSaving, setIsSaving] = useState(false)
	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [consultantCode, setConsultantCode] = useState('')
	const [storeName, setStoreName] = useState('')
	const [idNumber, setIdNumber] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')

	const handleEnableDisableClick = useCallback(
		async () => {
			setIsSaving(true)

			await firebase.firestore().doc(`/users/${userId}`).update('enabled', !(user.enabled !== false))

			setIsSaving(false)
		},
		[userId, user]
	)

	const handleSaveClick = useCallback(
		async () => {
			setIsSaving(true)
			await firebase.firestore().doc(`/users/${userId}`).set({
				firstName: firstName || '',
				lastName: lastName || '',
				consultantCode: consultantCode || '',
				storeName: storeName || '',
				idNumber: idNumber || '',
				phoneNumber: phoneNumber || '',
			}, {
				mergeFields: ['firstName', 'lastName', 'consultantCode', 'storeName', 'idNumber', 'phoneNumber']
			})
			setIsSaving(false)
		},
		[firstName, lastName, consultantCode, storeName, idNumber, phoneNumber, userId],
	)

	useEffect(
		() => {
			setFirstName(user?.firstName)
			setLastName(user?.lastName)
			setConsultantCode(user?.consultantCode)
			setStoreName(user?.storeName)
			setIdNumber(user?.idNumber)
			setPhoneNumber(user?.phoneNumber)
		},
		[user],
	)

	return (
		<div className="w-full mx-auto mt-4">
			<div className="bg-white rounded shadow-xs mt-4">
				<div className="border-t p-4">
					<h3 className="text-sm font-semibold mb-2">Points Balance</h3>
					<div className="flex text-2xl leading-none">
						{displayFormat(user?.pointsBalance || 0)}
					</div>
				</div>
				<div className="grid grid-cols-2">
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">First Name</h3>
						<input disabled={isSaving} type="text" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} />
					</div>
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">Last Name</h3>
						<input disabled={isSaving} type="text" value={lastName} onChange={(e) => { setLastName(e.target.value) }} />
					</div>
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">Consultant Code</h3>
						<input disabled={isSaving} type="text" value={consultantCode} onChange={(e) => { setConsultantCode(e.target.value) }} />
					</div>
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">Store Name</h3>
						<input disabled={isSaving} type="text" value={storeName} onChange={(e) => { setStoreName(e.target.value) }} />
					</div>
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">ID Number</h3>
						<input disabled={isSaving} type="text" value={idNumber} onChange={(e) => { setIdNumber(e.target.value) }} />
					</div>
					<div className="border-t p-4">
						<h3 className="text-sm font-semibold mb-2">Phone Number</h3>
						<input disabled={isSaving} type="text" value={phoneNumber} onChange={(e) => { setPhoneNumber(e.target.value) }} />
					</div>
				</div>
			</div>
			<div className="mt-4">
				<button disabled={isSaving} onClick={handleSaveClick} className="bg-blue-500 mr-2">Save Changes</button>
				<button disabled={isSaving} onClick={handleEnableDisableClick} className={`${(user?.enabled === false) ? 'bg-green-600' : 'bg-red-600'} mt-4`}>{(user?.enabled === false) ? 'Enable' : 'Disable'} user</button>
			</div>
		</div>
	)
}

export default UserDetails
